import script from "./SkuPddDpl.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkuPddDpl.vue?vue&type=script&setup=true&lang=ts"

import "./SkuPddDpl.vue?vue&type=style&index=0&id=8401d2ae&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8401d2ae"]])

export default __exports__